import { ActiveUser } from '~/components/settings/types'
import { getAvatarColorsForString } from '../styles/colors'

/**
 * Get a color class for an avatar based on the user's name.
 * @param user The user to get the avatar color for.
 * @returns The color class for the avatar.
 */
export function getAvatarColorsForUser(user?: Partial<ActiveUser>) {
  const stringForUser = user?.id || 'seed' // Use the user's ID if available, otherwise use a seed string.
  return getAvatarColorsForString(stringForUser)
}
